import { IKinship, determineKinships } from '@/common/constants/kinship';
import { TMarket } from '@/common/constants/markets';
import { requiredString } from '@/common/utils/zod';
import { endOfToday } from 'date-fns';
import { t } from 'i18next';
import { z } from 'zod';

export const kinshipSchema = (market: TMarket, hasSpouse: boolean) =>
  z
    .custom<IKinship>(Boolean, t('errors.input.required'))
    .superRefine((kinship, ctx) => {
      if (!determineKinships(market).some((k) => k.value === kinship?.value)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('errors.input.required'),
        });
      }

      if (hasSpouse && ['spouse', 'civil-partner'].includes(kinship?.value)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('dashboard.add_family_member.errors.already_has_spouse'),
        });
      }
    });

export const simulateAddFamilyMemberSchema = (
  market: TMarket,
  hasSpouse: boolean
) =>
  z.object({
    shortName: requiredString,
    type: kinshipSchema(market, hasSpouse),
    birthdate: z
      .date({
        invalid_type_error: 'errors.input.required',
        required_error: 'errors.input.required',
      })
      .max(endOfToday(), 'errors.input.invalid_date'),
  });

export type TSimulateAddFamilyMemberFormValues = z.infer<
  ReturnType<typeof simulateAddFamilyMemberSchema>
>;
